/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InboundDocumentScreenerResult } from './InboundDocumentScreenerResult';
import {
    InboundDocumentScreenerResultFromJSON,
    InboundDocumentScreenerResultFromJSONTyped,
    InboundDocumentScreenerResultToJSON,
    InboundDocumentScreenerResultToJSONTyped,
} from './InboundDocumentScreenerResult';

/**
 * 
 * @export
 * @interface SendInboundDocumentToScreener200Response
 */
export interface SendInboundDocumentToScreener200Response {
    /**
     * 
     */
    data: InboundDocumentScreenerResult;
}

/**
 * Check if a given object implements the SendInboundDocumentToScreener200Response interface.
 */
export function instanceOfSendInboundDocumentToScreener200Response(value: object): value is SendInboundDocumentToScreener200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SendInboundDocumentToScreener200ResponseFromJSON(json: any): SendInboundDocumentToScreener200Response {
    return SendInboundDocumentToScreener200ResponseFromJSONTyped(json, false);
}

export function SendInboundDocumentToScreener200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendInboundDocumentToScreener200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': InboundDocumentScreenerResultFromJSON(json['data']),
    };
}

export function SendInboundDocumentToScreener200ResponseToJSON(json: any): SendInboundDocumentToScreener200Response {
    return SendInboundDocumentToScreener200ResponseToJSONTyped(json, false);
}

export function SendInboundDocumentToScreener200ResponseToJSONTyped(value?: SendInboundDocumentToScreener200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': InboundDocumentScreenerResultToJSON(value['data']),
    };
}

